/* pm- sweepstakes page: entry dates, countdown, sticky bar. Loaded once by pm-Sticky CTA Bar. */
(function () {
  if (window.lpSweepsReady) return; window.lpSweepsReady = true;
  var PREVIEW = /[?&]preview\b/.test(location.search) || /[?&]preview_theme_id=/.test(location.search);
  function t(s) { var v = Date.parse(s); return isNaN(v) ? null : v; }

  // Entry forms: check the email, refuse entries outside the dates
  document.querySelectorAll('[data-lp-sweeps-entry]').forEach(function (box) {
    var form = box.querySelector('form'), email = box.querySelector('[data-lp-email]'), err = box.querySelector('[data-lp-err]');
    var start = t(box.dataset.start), end = t(box.dataset.end);
    if (!form || !email) return;
    form.addEventListener('submit', function (e) {
      var now = Date.now();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { e.preventDefault(); err.textContent = 'Enter a valid email so we can reach you if you win.'; email.setAttribute('aria-invalid', 'true'); email.focus(); return; }
      if (!PREVIEW && start && now < start) { e.preventDefault(); err.textContent = box.dataset.before; return; }
      if (!PREVIEW && end && now > end) { e.preventDefault(); err.textContent = box.dataset.after; return; }
      err.textContent = '';
    });
    email.addEventListener('input', function () { if (email.getAttribute('aria-invalid')) { email.removeAttribute('aria-invalid'); err.textContent = ''; } });
  });

  // Sticky bar: countdown, show when no form is on screen, jump to the hero form
  var bar = document.querySelector('[data-lp-sticky]');
  if (!bar) return;
  var start = t(bar.dataset.start), end = t(bar.dataset.end), cd = bar.querySelector('[data-lp-countdown]');
  function tick() {
    var now = Date.now();
    if (end && now > end) { cd.textContent = bar.dataset.after; return; }
    var target = start && now < start ? start : end; if (!target) return;
    var diff = Math.max(0, target - now), d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60;
    cd.textContent = (start && now < start ? bar.dataset.before : bar.dataset.during) + ' ' + d + 'd ' + h + 'h ' + m + 'm';
  }
  tick(); setInterval(tick, 20000);
  var forms = [].slice.call(document.querySelectorAll('[data-lp-sweeps-entry]'));
  if ('IntersectionObserver' in window && forms.length) {
    var seen = new Map();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
      var any = false; seen.forEach(function (v) { if (v) any = true; });
      bar.classList.toggle('is-shown', !any);
    });
    forms.forEach(function (f) { io.observe(f); });
  } else { bar.classList.add('is-shown'); }
  var hero = forms[0];
  document.querySelectorAll('a[href="#lp-sweeps-enter"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!hero) return; e.preventDefault();
      hero.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = hero.querySelector('[data-lp-email]'); if (input) input.focus({ preventScroll: true });
    });
  });
})();
